import { RootState } from 'redux/reducers/rootReducer';

const isBullhornConnectModalOpenSelector = (state: RootState) =>
  state.bullhorn.isConnectBullhornAccountModalOpen;

export { isBullhornConnectModalOpenSelector };
